<template>
    <div
        class="premium-price-card"
        :class="{
            'premium-price-card_accent': accent,
        }"
    >
        <div class="_dflex _justify-content-start _gap-8 _mb-16-8">
            <div
                class="premium-price-card__tag premium-price-card__tag_outline"
                :class="{
                    'premium-price-card__tag_color-green': accent,
                }"
            >
                <span
                    class="premium-price-card__icon premium-price-card__icon_crown _mr-8"
                    :class="{
                        'premium-price-card__icon_color-green': accent,
                    }"
                />
                Премиум
            </div>
            <div class="premium-price-card__tag premium-price-card__tag_filled premium-price-card__tag_color-green">
                {{ name }}
            </div>
        </div>
        <p class="p2 text-white premium-price-card__title" v-html="title">
        </p>
        <div class="text-white _mt-16 premium-price-card__price">
            <div v-if="price.text" class="p2">
                {{ price.text }}
            </div>
            <div v-if="price.value">
                <span class="h4">{{ price.value.toLocaleString() }} ₽</span>
                <span class="p2">/мес.</span>
                <tooltip v-if="!!price.tooltip" :text="price.tooltip" color="white" icon="info" size="md"/>
            </div>
        </div>
        <hr class="premium-price-card__hr">
        <ul class="premium-price-card__options">
            <li
                v-for="(item, i) in options"
                :key="i"
                class="_dflex"
                :class="{
                    [`${i === options.length - 1 ? '_mb-0' : '_mb-16'}`]: true,
                }"
            >
                <div class=" _mr-16">
                    <span
                        class="premium-price-card__icon premium-price-card__icon_check"
                        :class="{
                            'premium-price-card__icon_color-green premium-price-card__icon_shadow': !item.disabled,
                            'premium-price-card__icon_color-grey': item.disabled,
                        }"
                    />
                </div>
                <div>
                    <span
                        v-html="item.content"
                        class="p2 text-white"
                        :class="{
                            'text-white': !item.disabled,
                            'premium-price-card_text-inactive': item.disabled,
                        }"
                    /><nobr>&nbsp;<tooltip v-if="!!item.tooltip" :text="item.tooltip" color="white" icon="info" size="md"/></nobr>
                </div>
            </li>
        </ul>
        <hr class="premium-price-card__hr">
        <a
            v-if="actionLink"
            class="button button_white button_width-100 _mt-40-24"
            :href="actionLink"
            v-js-anchor="{ disabled: !`${actionLink}`.startsWith('#')}"
        >
            Подать заявку
        </a>
    </div>
</template>
<script>
export default {
    name: 'PremiumPriceCard',
    props: {
        name: String,
        title: String,
        /**
         * @typedef {Object} Option
         * @property {string} content
         * @property {string} tooltip
         * @property {boolean} disabled
         * /
        /** @type {Option[]} */
        options: {
            type: Array,
            default: () => [],
        },
        /**
         * @typedef {Object} Price
         * @property {number} value
         * @property {string} tooltip
         */
        /** @type {Price} */
        price: {
            type: Object,
            default: () => ({}),
        },
        actionLink: String,
        accent: Boolean,
    },
}
</script>
<style lang="scss">
@import "/local/templates/redesign/src/assets/scss/base/_variables.scss";
@import "/local/templates/redesign/src/assets/scss/base/_mixins.scss";
@import "/local/templates/redesign/src/assets/scss/base/_functions.scss";

.premium-price-card {
    --premium-price-card-border: #9E9E9E;

    position: relative;
    @include fluid(border-radius, 24px);
    @include fluid(padding-top, 32px, 24px);
    @include fluid(padding-bottom, 32px, 24px);
    @include fluid(padding-left, 32px, 16px);
    @include fluid(padding-right, 32px, 16px);
    background: rgba(255, 255, 255, .08);
    @include fluid(min-height, 769px, 575px);

    @include mobile {
        height: auto;
    }

    &:before {
        content: "";
        @include fluid(border-radius, 24px);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        outline: 2px solid var(--premium-price-card-border);
        outline-offset: -2px;
        mask-image: linear-gradient(135deg, black 80%, rgba(0,0,0,.1));
        z-index: -1;
    }

    &_accent {
        --premium-price-card-border: #1ECF9A;
        background: rgba(0, 0, 0, .12);
    }

    &__tag {
        border: 1px solid transparent;
        @include fluid(height, 30px);
        @include fluid(font-size, 16px);
        @include fluid(line-height, 20px);
        text-transform: uppercase;
        @include fluid(padding-top, 6px);
        @include fluid(padding-bottom, 6px);
        @include fluid(padding-left, 10px);
        @include fluid(padding-right, 10px);
        border-radius: 9999px;
        --premium-price-card-tag-text: white;
        --premium-price-card-tag-color: white;

        &_outline {
            border-color: var(--premium-price-card-tag-color);
            color: var(--premium-price-card-tag-color);
        }

        &_filled {
            background-color: var(--premium-price-card-tag-color);
            color: var(--premium-price-card-tag-text);
        }

        &_color {
            &-green {
                --premium-price-card-tag-text: #{$grey-1514};
                --premium-price-card-tag-color: #{$green-premium};
            }
        }
    }

    &__icon {
        --premium-price-card_icon-color: white;
        --premium-price-card_icon-image: black;

        &:before {
            content: "";
            @include fluid(width, 16px);
            @include fluid(height, 16px);
            display: inline;
            float: left;
            mask-repeat: no-repeat;
            mask-size: contain;
            mask-position: center;
            background: var(--premium-price-card_icon-color);
            mask-image: var(--premium-price-card_icon-image);
        }

        &_crown {
            --premium-price-card_icon-image: url('/local/templates/redesign/src/assets/img/premium/icons/crown.svg');
        }

        &_check {
            --premium-price-card_icon-image: url('/local/templates/redesign/src/assets/img/premium/icons/check1.svg');
        }

        &_color {
            &-green {
                --premium-price-card_icon-color: #{$green-premium};
            }
            &-grey {
                --premium-price-card_icon-color: #{$grey-517};
            }
        }

        &_shadow {
            filter: drop-shadow(0px 0px 5px var(--premium-price-card_icon-color));
        }
    }

    &_text-inactive {
        color: $grey-517;
    }

    &__hr {
        @include fluid(margin-top, 24px, 16px);
        @include fluid(margin-bottom, 24px, 16px);
        border: none;
        border-bottom: 1px solid $grey-517;
    }

    &__options {
        @include fluid(min-height, 280px, 180px);
    }

    &__title {
        @include fluid(min-height, 60px, 64px);
    }

    &__price {
        @include fluid(min-height, 48px);
    }
}
</style>
